import { jsx as _jsx } from "react/jsx-runtime";
import cx from "classnames";
import React from "react";
import SwiperCore, { A11y, Navigation, Pagination } from "swiper";
import { Swiper } from "swiper/react";
import styles from "./carousel-wrapper.module.css";
SwiperCore.use([
    Navigation,
    Pagination,
    A11y
]);
export const CarouselWrapper = ({ children , clickablePagination =true , isCarouselReady =true , customClassNames , ariaLabel ="carousel" , name , swiperSettings  })=>{
    const a11yOptions = {
        enabled: true
    };
    const wrapperClassNames = cx(styles.carouselWrapper, customClassNames === null || customClassNames === void 0 ? void 0 : customClassNames.wrapper, {
        [styles.showCarousel]: isCarouselReady
    });
    const carouselClassNames = cx(name, customClassNames === null || customClassNames === void 0 ? void 0 : customClassNames.carousel);
    const paginationSettings = {
        el: `.${name}-pagination`,
        clickable: clickablePagination,
        dynamicBullets: true
    };
    const navigationSettings = {
        prevEl: `.${name}-prev`,
        nextEl: `.${name}-next`
    };
    return /*#__PURE__*/ _jsx("section", {
        className: wrapperClassNames,
        "aria-label": ariaLabel,
        children: /*#__PURE__*/ _jsx(Swiper, {
            className: carouselClassNames,
            pagination: paginationSettings,
            a11y: a11yOptions,
            navigation: navigationSettings,
            ...swiperSettings,
            children: children
        })
    });
};
export default CarouselWrapper;
